module.exports = __webpack_public_path__ + "files/1e095e493f27f0d09ac75679773b47af.png";